import React from 'react';
import SearchIcon from '@mui/icons-material/Search';
import styles from './HandlerRegistry.module.scss';

interface HandlerRegistrySearchProps {
    value: string;
    onChange: (value: string) => void;
}

const HandlerRegistrySearch: React.FC<HandlerRegistrySearchProps> = ({ value, onChange }) => (
    <div className={styles.searchBar}>
        <SearchIcon className={styles.searchIcon} />
        <input
            className={styles.searchInput}
            type="text"
            placeholder="Search"
            value={value}
            onChange={(e) => onChange(e.target.value)}
        />
    </div>
);

export default HandlerRegistrySearch;
